<template>
    <card 
    :title="$trans(section.name)"
    class="mb-4">

        <div class="row">

            <form-row 
            v-for="row in rows"
            :key="'row-'+row.id" 
            :row="row" /> 

        </div> <!-- /.row --> 

        <form-section 
        v-for="section in sections"
        :key="'section-'+section.id" 
        :section="section" />

    </card>
</template>


<script>

    export default {

        props: {

            section: {
                type: Object,
                default: () => {}
            },

            sections: {
                type: Array,
                default: () => []
            },
            
            rows: {
                type: Array,
                default: () => []
            }
            
        }

    }

</script>